module.exports = __webpack_public_path__ + "media/images/doctor-day/doctorday-template-uz-b1de6e177f7f651acd3de6ee1129de7e.png";